import React from 'react';
import db_lib from 'xAppLib/libs/db_lib';
import API_service from 'xAppLib/providers/API_service'
import SimpleShowMore from '../xAppLib/UIelems/SimpleShowMore';
import cat_model, { cat_nms } from 'models/cat_model';
import { Icon } from 'semantic-ui-react';

const _FRDB_LOC = 'meds';

const _DET_FIELDS = {

			'itm_tp': 'Item Type',

			'base_mid': 'Base med ID',
			'need_patho': 'Required Pathology',

			'name': 'name',
			'alt_name': 'Alt names',
			'ain': 'Active ingredient names',
			'size': 'size',
			'qnty': 'quantity',
			'dose': 'dosage',
			'repeats': 'repeats',
			'days_limit': 'script limit (in days)',
			'nmper_limit': 'total scrs number limit in 6 months',
			'authority_code': 'Authority code number (or "auto")',
			'phone_appr': 'Phone approval number',
			'extra': 'Extra text on script',

			'FU_days': 'Allow booking FU after (in days)',
			'FU_mid': 'MedID of the FU consult',

			'tp_mid': 'MedID of the Treatment Plan consult',
			'tp_alt': 'Other Treatment Plans on which this med is available',
			'tp_rpt': 'Treatment Plan Repeats', // e.g. { r:5, i:28, p:'d' } repeats 5 times every 28 days
			'tp_rpt_adj': 'Flexible Repeats', // Allow the doctor to set the repeats 2x normal. Boolean now, but could be a list of multipliers in future

			'xc_avail': 'Allow Express Consults',
			'med_warn': 'Warning/Disclaimer to show on Med Req page',

			'mc_pr': 'Charge for medical consultation in App',
			'mc_mb_pr': 'Charge for medical consultation when MedBuy in App',
			'mc_ph_pr': 'Charge for medical consultation in Pharm Terminal',
			// 'medbuy_price': 'MedBuy medication price',
			// 'medbuy_conc_price': 'MedBuy concession medication price',
			// 'medbuy_nomedicare_price': 'MedBuy no Medicare card medication price',
			// 'medbuy_gen_price': 'MedBuy Generic medication price',
			// 'medbuy_gen_conc_price': 'MedBuy Generic concession medication price',
			// 'medbuy_gen_nomedicare_price': 'MedBuy Generic no Medicare card medication price',
			// 'medbuy_supp_oid': 'MedBuy supplier OID',

			
			'PBSCode': 'PBS Code',
			'PI': 'Product Information',
			'CMI': 'Consumer Medicines Information',
			
			'IL': 'Info Link',
			
			'xtra': 'extra configuration',
			'epresc': 'ePrescribing data fields',

			'tga_cat': "TGA Document Cat"
			// 'monthly_limit': 'monthly limit',
		}

const _PATHO_FIELDS = {
	'itm_tp': 'Item Type',

	'name': 'name',
	'patho_req_txt': 'Pathology Request',
	'base_mid': 'Base med ID',
	'days_limit': 'script limit (in days)',
	'items': 'Tests',
	'instructions':'Additional instructions for patient',
	'definition': 'Definition',
	'itm_lock':'Tests cannot be chosen',
	'IL': 'Info Link',
	'xtra': 'extra configuration',
}

const _ITEM_TYPE = [
	{ key: 'scr', value: 'scr', text: 'Script Request' },
	{ key: 'doccons', value: 'doccons', text: 'Doctor Consultation Request' },
	{ key: 'subcons', value: 'subcons', text: 'Treatment Plan Consult Request' },
	{ key: 'patho', value: 'patho', text: 'Pathology Request' },
	{ key: 'cert', value: 'cert', text: 'Medical Certificate Request' },
	{ key: 'refr', value: 'refr', text: 'Referral Request' },
]


const _MB_FIELDS = {
			'medbuy_price': 'MedBuy medication price',
			'medbuy_conc_price': 'MedBuy concession medication price',
			'medbuy_nomedicare_price': 'MedBuy no Medicare card medication price',
			'medbuy_gen_price': 'MedBuy Generic medication price',
			'medbuy_gen_conc_price': 'MedBuy Generic concession medication price',
			'medbuy_gen_nomedicare_price': 'MedBuy Generic no Medicare card medication price',
			'medbuy_supp_oid': 'MedBuy supplier OID',
		}


const _TGA_DOCUMENT_CATS = [
	{ key: 0, value: null, text: 'None' },
	{ key: '1-cap', value: '1-cap', text: 'Category 1-CBD medicinal cannabis product (CBD≥98%) - Capsule' },
	{ key: '1-herb', value: '1-herb', text: 'Category 1-CBD medicinal cannabis product (CBD≥98%) - Herb, dried (for vaporisation)' },
	{ key: '1-inh', value: '1-inh', text: 'Category 1-CBD medicinal cannabis product (CBD≥98%) - Inhalation' },
	{ key: '1-oraliq', value: '1-oraliq', text: 'Category 1-CBD medicinal cannabis product (CBD≥98%) - Oral Liquid' },
	{ key: '1-patch', value: '1-patch', text: 'Category 1-CBD medicinal cannabis product (CBD≥98%) - Patch, dermal' },
	{ key: '1-topic', value: '1-topic', text: 'Category 1-CBD medicinal cannabis product (CBD≥98%) - Topical' },
	
	{ key: '2-cap', value: '2-cap', text: 'Category 2-CBD dominant medicinal cannabis product (CBD≥60% and less than 98%) - Capsule' },
	{ key: '2-herb', value: '2-herb', text: 'Category 2-CBD dominant medicinal cannabis product (CBD≥60% and less than 98%) - Herb, dried (for vaporisation)' },
	{ key: '2-inh', value: '2-inh', text: 'Category 2-CBD dominant medicinal cannabis product (CBD≥60% and less than 98%) - Inhalation' },
	{ key: '2-oraliq', value: '2-oraliq', text: 'Category 2-CBD dominant medicinal cannabis product (CBD≥60% and less than 98%) - Oral Liquid' },
	{ key: '2-patch', value: '2-patch', text: 'Category 2-CBD dominant medicinal cannabis product (CBD≥60% and less than 98%) - Patch, dermal' },
	{ key: '2-topic', value: '2-topic', text: 'Category 2-CBD dominant medicinal cannabis product (CBD≥60% and less than 98%) - Topical' },

	{ key: '3-cap', value: '3-cap', text: 'Category 3-Balanced medicinal cannabis product (CBD less than 60% and ≥40%) - Capsule' },
	{ key: '3-herb', value: '3-herb', text: 'Category 3-Balanced medicinal cannabis product (CBD less than 60% and ≥40%) - Herb, dried (for vaporisation)' },
	{ key: '3-inh', value: '3-inh', text: 'Category 3-Balanced medicinal cannabis product (CBD less than 60% and ≥40%) - Inhalation' },
	{ key: '3-oraliq', value: '3-oraliq', text: 'Category 3-Balanced medicinal cannabis product (CBD less than 60% and ≥40%) - Oral Liquid' },

	{ key: '4-cap', value: '4-cap', text: 'Category 4-THC dominant medicinal cannabis product (THC 60-98%) - Capsule' },
	{ key: '4-herb', value: '4-herb', text: 'Category 4-THC dominant medicinal cannabis product (THC 60-98%) - Herb, dried (for vaporisation)' },
	{ key: '4-inh', value: '4-inh', text: 'Category 4-THC dominant medicinal cannabis product (THC 60-98%) - Inhalation' },
	{ key: '4-oraliq', value: '4-oraliq', text: 'Category 4-THC dominant medicinal cannabis product (THC 60-98%) - Oral Liquid' },

	{ key: '5-cap', value: '5-cap', text: 'Category 5-THC medicinal cannabis product (THC greater than 98%) - Capsule' },
	{ key: '5-herb', value: '5-herb', text: 'Category 5-THC medicinal cannabis product (THC greater than 98%) - Herb, dried (for vaporisation)' },
	{ key: '5-inh', value: '5-inh', text: 'Category 5-THC medicinal cannabis product (THC greater than 98%) - Inhalation' },
	{ key: '5-oraliq', value: '5-oraliq', text: 'Category 5-THC medicinal cannabis product (THC greater than 98%) - Oral Liquid' },

]

const _MODEL_NAME = 'med_model';

const MAX_ROW_LENGTH = 30;

const _MEDS_FIELDS = [
	{
		name: 'code',
		jpath: 'key'
	},
	{
		name: 'name',
		jpath: 'name',
		type: 'show_more',
		cut_length: MAX_ROW_LENGTH
	},
	{
		name: 'alt name',
		jpath: 'alt_name',
		type: 'show_more',
		cut_length: MAX_ROW_LENGTH
	},
	{
		name: 'active',
		template: ({ value: { active } }) => <Icon color={active ? 'green' : 'red'} name={active ? 'check' : 'close'} />
	},
	{
		name: 'category',
		jpath: 'par_nm',
		type: 'show_more',
		cut_length: MAX_ROW_LENGTH
	},
	{
		name: 'PBSCode',
		jpath: 'PBSCode'
	},
	{
		name: 'dosage',
		template: ({ value: { size, qnty } }) => <SimpleShowMore cut_length={MAX_ROW_LENGTH} content={size && qnty ? `${size} X ${qnty}` : size || qnty} />
	},
	{
		name: 'script limit',
		template: ({ value: { days_limit, epresc: { NumberOfRepeatsAuthorised: repeat } = {} } }) =>
			`${days_limit && repeat ? `${days_limit} days, ${repeat} repeat` : days_limit ? `${days_limit} days` : repeat ? `${repeat} repeat` : ''}`
	}
];

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

export default class med_model extends db_lib {

	static get FRDB_LOC() { return _FRDB_LOC; }
	static get DET_FIELDS() { return _DET_FIELDS; }
	static get MB_FIELDS() { return _MB_FIELDS; }
	static get PATHO_FIELDS() { return _PATHO_FIELDS; }
	static get MODEL_NAME() { return _MODEL_NAME; }
	static get ITEM_TYPE() { return _ITEM_TYPE; }
	static get MEDS_FIELDS() { return _MEDS_FIELDS; }
	static get CAT_NAMES() { return cat_nms; }
	static get TGA_DOCUMENT_CATS() { return _TGA_DOCUMENT_CATS; }

//	------------------------	------------------------	------------------------
//	------------------------	------------------------	------------------------

	static det_fields_scr() {

		return [
				'name',
				'size',
				'qnty',
				'dose',
				'repeats',
				'days_limit',
				'authority_code',
				'phone_appr',
				'extra',
			]

	}

//	------------------------	------------------------	------------------------

	static det_fields_show_user() {

		return {
			'name': 'name',
			'size': 'size',
			'qnty': 'quantity',
			'dose': 'dosage',
			'repeats': 'repeats',
		}

	}

	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------

	static async get_pbs_meds_list () {

		if (!app.app_data.ws_data?.pbs_meds_list) {

			if (!app.app_data.ws_data)				app.app_data.ws_data = {};
			app.app_data.ws_data.pbs_meds_list = (await API_service.load_data('get_pbs_meds_list'))?.data ||[];

		}

		return app.app_data.ws_data.pbs_meds_list;

	}
	
	static async items(med) {
		if (!med?.items)
			return null
		return await Promise.all(med.items.map(async k=>{
			let record
			if (typeof k == 'string') {
				record = await this.load_med(  k, {refresh:true} )
				record.key = k
			} else {
				record = k
			}
			return record
		})) 
	}

	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------


	static watch_med (mid, ca, p) {

		return this.watch_record( mid, async (med, key) => ca( await this.load_med(null, p, med) ) )
	}

	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------

	static async load_med (mid, p, med) {


		med ||= mid && await this.get_record(mid, null, p);

		if (!med)
			return

		if (med?.base_mid) {
			const base_med = await this.load_med(med.base_mid);
			med = {...base_med, ...med, q:{...base_med?.q, ...med?.q}}
		}

		if (p?.load_items && med?.items) {
			await Promise.all(
				med.items.map( async m => {
						const item_med = await this.load_med(m);
						console.log('adding item', item_med);
						med.q = {...item_med?.q, ...med?.q}
					} ) )
		}

		return med;
	}

	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------

	static async get_all_meds_data () {

		if (!app.app_data.ws_data?.all_meds_data) {

			if (!app.app_data.ws_data)				app.app_data.ws_data = {};
			app.app_data.ws_data.all_meds_data = await med_model.get_record( '/' )

			// console.log('get_all_meds_data', app.app_data.ws_data.all_meds_data);

		}

		return app.app_data.ws_data.all_meds_data;

	}

	static async get_all_meds_extra_data() {
		const catNames = this.CAT_NAMES.map((cn) => cn === 'pharm' ? '' : cn);
		const [allMeds, ...CatMeds] = await Promise.all([this.get_all_meds_data(), ...catNames.map((cat_nm) => cat_model.get_cat_list({ cat_nm, all: true, prefix_par_nm: true }))]).catch((err) =>
			console.error('Failed to load categories', err)
		);
		const combineAllCatMeds = CatMeds.map((cat) => cat.cat_show_list).reduce((acc, curr) => Object.assign(acc, curr), {});

		const { medsWithActAndCat, medsMissingInAllMeds } = Object.entries(allMeds).reduce((acc, [k, v]) => {
			if (!combineAllCatMeds[v.m]) {
				acc.medsMissingInAllMeds.push(v);
			}

			acc.medsWithActAndCat.push({
				...v,
				key: k,
				active: combineAllCatMeds[k]?.active === undefined || combineAllCatMeds[k]?.active,
				par_nm: combineAllCatMeds[k]?.par_nm || undefined
			});

			return acc;
		}, { medsWithActAndCat: [], medsMissingInAllMeds: [] });


		const medsMissingInCat = Object.entries(combineAllCatMeds)
			.filter(([k, v]) => v.t === 'm' && !allMeds[k])
			.map(([k, v]) => ({ id: k, name: v.n, category: v.par_nm }));

		return { data: medsWithActAndCat, medsMissingInCat, medsMissingInAllMeds };
	}

}
